import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrestacionPdfService {
  constructor(private http: HttpClient) { }

  downloadPrestacionPdf(sessionId: string, prestacion: any): Observable<Blob> {
    const payload = {
      sessionId: sessionId,
      prestacion
    };

    return this.http.post(`${environment.urlApi}discapacidad/downloadPrestacionPdf`, payload, { responseType: 'blob' });
  }

  triggerDownload(pdfBlob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(pdfBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}